/**
 * Client-side hydration utilities for static-generated pages
 */

export interface PreloadedData {
  artwork?: any;
  [key: string]: any;
}

/**
 * Extract preloaded data from the static HTML
 */
export function getPreloadedData(): PreloadedData | null {
  if (typeof window === 'undefined') return null;
  
  try {
    const script = document.getElementById('preloaded-data');
    if (!script?.textContent) return null;
    
    const data = JSON.parse(script.textContent);
    // Remove the script element to clean up the DOM
    script.remove();
    return data;
  } catch (error) {
    console.warn('Failed to parse preloaded data:', error);
    return null;
  }
}

/**
 * Check if we're running in static generation mode
 */
export function isStaticGeneration(): boolean {
  return typeof window === 'undefined' || process.env.NODE_ENV === 'static';
}

/**
 * Get the current route for static generation
 */
export function getStaticRoute(): string {
  if (typeof window === 'undefined') {
    // In static generation, we need to determine the route from context
    return process.env.STATIC_ROUTE || '/';
  }
  return window.location.pathname;
}

/**
 * Initialize client-side routing after hydration
 */
export function initializeRouting() {
  if (typeof window === 'undefined') return;
  
  // Ensure the router initializes with the correct path
  const currentPath = window.location.pathname;
  if (currentPath !== '/') {
    // Update wouter's internal state
    history.replaceState(null, '', currentPath);
  }
}